export default __webpack_public_path__ + "static/media/wedding-party-create-background.503fc1bc.jpg";